module.exports = __webpack_public_path__ + "media/audios/audio_placeholder3-f8ba568f28fbe3b28af722bec056ee4b.mp3";